const getElementsContent = (elements) => {
  const template = document.createElement('template');
  const clonedElements = elements.map((element) => element.cloneNode(true));
  template.content.append(...clonedElements);
  return template.innerHTML;
};

export default getElementsContent;
